import { NonIdealState, Spinner } from "@blueprintjs/core";
import { type Post } from "@package/ui-gql/index-data-access";
import { useWallProvider } from "@package/ui-wall";
import { MediaDisplay } from "@package/ui-wall-components";
import { useFlyoutSearchState } from "../SearchContextProvider/context-flyout-search";

type SearchViewPostsTileProps = {
  post: Post;
};

function SearchViewPostsTile({ post }: SearchViewPostsTileProps) {
  const provider = useWallProvider();
  const { large, screen } = useFlyoutSearchState();
  const classNameMedia = large ? "max-h-80" : "max-h-48";

  return (
    <div className="relative mr-8 mb-8">
      {!!post.relatedPostAsset && (
        <div
          className="relative"
          onPointerDown={() =>
            post.id &&
            screen?.id &&
            provider?.onPostFlyoutDirectActivation(screen.id, post.id)
          }
        >
          <div className={classNameMedia}>
            <MediaDisplay
              id={post.relatedPostAsset}
              classNameMedia={classNameMedia}
              forceFit
            />
          </div>
        </div>
      )}
    </div>
  );
}

export function SearchViewPosts() {
  const { error, loading, posts } = useFlyoutSearchState();

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center h-full w-full">
        <NonIdealState
          icon="error"
          title="Error"
          description="Error loading Tiles for Search"
        />
      </div>
    );
  }

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center h-full w-full">
        <Spinner size={200} />
      </div>
    );
  }

  return (
    <div className="relative w-full h-full flex flex-wrap justify-center items-center content-center">
      {posts.map((post) => (
        <SearchViewPostsTile key={post.id} post={post} />
      ))}
    </div>
  );
}
